import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import AlertIcon from '../../assets/icons/alertNotify.svg';

const Container = styled.div`
  width: 100%;
  height: fit-content;
`;

const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
`;

const ContainerInfo = styled.div`
  position: ${({ device }) => (device !== 'mobile' ? 'absolute' : 'relative')};
  right: 0px;
  color: ${select('grayDarkLight')};
  display: flex;
  justify-content: center;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  margin-top: ${({ device }) => (device !== 'mobile' ? '0' : '20')}px;
  ${({ ratingsError }) =>
    ratingsError &&
    css`
      filter: blur(3px);
    `}
`;

const Icon = styled.div`
  width: 40px;
  height: 40px;
  background-image: ${({ icon }) => `url(${icon})`};
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 16px;
`;

const TitleText = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: ${({ fontSize }) => (!fontSize ? '16px' : fontSize)};
  line-height: 130%;
  height: 21px;
  margin-right: 9px;
  margin-bottom: ${({ mBottom }) => (!mBottom ? '0' : mBottom)};
`;

const TooltipComponent = styled.div`
  padding: 3px 8px;
  width: 280px;
  height: 25px;
  white-space: pre-wrap;
  text-align: center;
`;

const IconTooltip = styled.img`
  margin-top: 6px;
`;

const IconInfo = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`;

const MainArea = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device !== 'mobile' ? 'row' : 'column')};
  justify-content: ${({ device }) => (device !== 'mobile' ? 'space-between' : 'center')};
  align-items: ${({ device }) => (device !== 'mobile' ? 'flex-start' : 'center')};
  gap: ${({ device }) => (device === 'desktop' ? '74.15px' : '54px')};
  ${({ notRespondedCount }) =>
    notRespondedCount &&
    css`
      margin-bottom: ${({ device }) => (device !== 'mobile' ? '0' : '0')}px;
    `};
  ${({ device }) =>
    device === 'tablet' &&
    css`
      margin-bottom: ${({ notRespondedCount }) => (notRespondedCount ? '20' : '20')}px;
    `};
`;

const LeftSide = styled.div`
  width: ${({ device }) => (device !== 'mobile' ? '298px' : '100%')};
  display: flex;
  gap: 18px;
  flex-direction: column;
  justify-content: ${({ device }) => (device !== 'mobile' ? 'flex-start' : 'center')};
  align-items: ${({ device }) => (device !== 'mobile' ? 'flex-start' : 'center')};
  .emptyState {
    font-size: 16px;
  }
`;

const ContainerRaitings = styled.div`
  width: 95%;
  height: 67px;
  justify-content: space-between;
  gap: ${({ device }) => (device !== 'mobile' ? '16px' : '7px')};
  margin-bottom: 14px;
  margin-right: 60px;
`;

const ContainerValue = styled.div`
  height: ${({ device }) => (device === 'desktop' ? '43px' : '')};
  font-family: 'Hind';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 106%;
  display: flex;
  align-items: flex-end;
  margin-top: 5px;
`;

const Rating = styled.div`
  width: 80px;
  display: flex;
  gap: 6px;
  flex-direction: column;
  justify-content: flex-start;
  .value-text {
    font-family: 'Hind';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
  }
`;

const RightSide = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      width: 59%;
    `};
`;

const LinkToHelp = styled.a`
  display: flex;
  align-self: center;
  color: ${select('black')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  margin-top: 14px;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      gap: 26px;
    `};
  @media screen and (max-width: 1330px) {
    gap: ${({ device }) => device === 'desktop' && '20px'};
  }
`;

const RatingText = styled.div`
  width: 100%;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: ${({ isBrasilSite, device }) => {
    if (isBrasilSite && device === 'mobile') return '12px';
    if (isBrasilSite && device !== 'mobile') return '13px';
    return '14px';
  }};
  line-height: 22px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      min-width: 125px;
    `};
`;

const ProgressBarRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ isBrasilSite, device }) => (isBrasilSite && device === 'mobile' ? '1px' : '8px')};
  .containerValue {
    display: flex;
    gap: 3px;
  }
  .value {
    min-width: 20px;
    font-family: 'Hind';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 130%;
    margin-top: 3px;
  }
  ${({ device }) =>
    device === 'tablet' &&
    css`
      width: 270px;
    `};
`;

const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${select('redBack')};
  height: 30px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  position: absolute;
  left: 0px;
  bottom: 0px;
`;

const Alert = styled.div`
  background-image: ${`url(${AlertIcon})`};
  background-size: contain;
  background-repeat: no-repeat;
  width: 15px;
  height: 15px;
  margin-right: 4px;
`;

const Message = styled.div`
  font-size: 12px;
  font-family: 'Hind';
  color: ${select('negative')};
  display: flex;
  > span,
  b {
    margin-left: 3px;
  }
`;

const TotalvalueContainer = styled.div`
  width: 100%;
`;

const TotalValueSpan = styled.div`
  font-family: Hind;
  font-size: ${({ device }) => (device !== 'mobile' ? '16' : '14')}px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  color: ${select('midDarkGrayAux')};
`;

const CommentEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  height: 297px;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 12%;
  white-space: normal;
  text-align: center;
  margin-top: ${({ device }) => device !== 'mobile' && '40px'};
`;

const MoreComments = styled.button`
  height: 40px;
  cursor: pointer;
  color: ${select('black')};
  text-align: center;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 0px 12px;
`;

const ChevronDown = styled.img`
  width: 16px;
  margin-bottom: 3px;
`;

const ModalContainer = styled.div`
  width: 588px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${select('white')};
  padding: 40px 32px 32px;
`;

const CommentsContainer = styled.div`
  max-height: ${({ height }) => height || '400px'};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  /* width */
  ::-webkit-scrollbar {
    width: 11px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 32px;
    border: 5px solid ${select('white')};
    // border color does not support transparent on scrollbar
    background-color: ${select('middleGray')};
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${select('midLightGray')};
    border-radius: 32px;
  }
`;

const BottomSheetContainer = styled.div`
  padding: 0 4px 20px 20px;
`;

const BottomSheetTitle = styled.div`
  font-family: Hind;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  text-align: center;
  margin-bottom: 48.88px;
`;

const HeaderSectionContainer = styled.div`
  justify-content: center;
  align-items: center;
  gap: 16px;
  display: ${({ device }) => (device === 'desktop' ? 'inline-flex' : 'inline-flex')};
  align-items: center;
`;

const MobileBajadaContainer = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22.41px;
  padding-top: 8px;
  white-space: normal;
`;

const ContainerValueMobile = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 106%;
  padding-top: 8px;
`;

const TitleContainer = styled.div`
  font-family: 'Hind';
  font-weight: 600;
  font-size: 20px;
  line-height: '26px';
  white-space: pre-line;
`;

export {
  Container,
  HeaderArea,
  Icon,
  TitleText,
  TooltipComponent,
  IconTooltip,
  IconInfo,
  ContainerInfo,
  MainArea,
  LeftSide,
  ContainerRaitings,
  ContainerValue,
  Rating,
  RightSide,
  ProgressBarContainer,
  RatingText,
  ProgressBarRow,
  MessageContainer,
  Alert,
  Message,
  TotalvalueContainer,
  TotalValueSpan,
  LinkToHelp,
  MoreComments,
  ChevronDown,
  ModalContainer,
  CommentsContainer,
  BottomSheetContainer,
  BottomSheetTitle,
  CommentEmptyState,
  HeaderSectionContainer,
  MobileBajadaContainer,
  ContainerValueMobile,
  TitleContainer
};
